
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4a2 2 0 11-4 0 2 2 0 014 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 22a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 22a4 4 0 00.24-7.993L17.313 11H18a1 1 0 000-2h-2.586l-1.917-1.917a2 2 0 00-2.976.165l-2.62 3.276a2 2 0 00.452 2.913l3.006 2.004-.83 3.316a1 1 0 001.941.485l.905-3.62c.16-.637-.099-1.307-.646-1.671l-3.267-2.178 2.621-3.276 2.047 2.047c.29.29.68.453 1.09.456l1.046 3.394A4 4 0 0018 22zm0-2a2 2 0 100-4 2 2 0 000 4z"}})])
          )
        }
      }
    